import script from "./RankingClubsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RankingClubsPage.vue?vue&type=script&setup=true&lang=js"

import "./RankingClubsPage.vue?vue&type=style&index=0&id=658afae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-658afae6"]])

export default __exports__